export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14924.ade9d612.jpg";